import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import dayjs from "dayjs";
import { api } from "../api";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const SET_LOADING = "saga/pastDuesPerformance/SET_LOADING";
export const SET_DATES = "saga/pastDuesPerformance/SET_DATES";
export const SET_FILTERS_DIRTY = "saga/pastDuesPerformance/SET_FILTERS_DIRTY";
export const SET_UPDATES_LOADING = "saga/pastDuesPerformance/SET_UPDATES_LOADING";

export const RESET_FILTER = "saga/pastDuesPerformance/RESET_FILTERS";

export const FETCH_CURRENT_USER = "saga/pastDuesPerformance/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/pastDuesPerformance/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CHART_SUCCESS = "saga/pastDuesPerformance/FETCH_CHART_SUCCESS";

export const UPDATE_DATES = "saga/pastDuesPerformance/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "saga/pastDuesPerformance/UPDATE_CUSTOM_RANGE";
export const UPDATE_PDC_TYPE = "saga/pastDuesPerformance/UPDATE_PDC_TYPE";
export const UPDATE_PAYMENT_STATUS = "saga/pastDuesPerformance/UPDATE_PAYMENT_STATUS";
export const UPDATE_CHART = "saga/pastDuesPerformance/UPDATE_CHART";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updatePdcType: createAction(UPDATE_PDC_TYPE),
  updatePaymentStatus: createAction(UPDATE_PAYMENT_STATUS),
  updateData: createAction(UPDATE_CHART),
  resetFilters: createAction(RESET_FILTER)
};

export default function* watcher() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(RESET_FILTER, resetFilters);
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  yield put({ type: SET_LOADING, payload: true });

  yield setDates();

  try {
    yield fetchValues();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchValues() {
  const params = yield getApiParams();

  try {
    let { data } = yield call(api.getValues, { params });

    yield put({
      type: FETCH_CHART_SUCCESS,
      payload: data
    });
  } catch (err) {
    console.error(err);
  }
}

function* getApiParams() {
  let {
    startDate: start_date,
    endDate: end_date,
    pdcType,
    paymentStatus
  } = yield select((state) => state.pastDuesPerformance.selectedFilters);
  let { short_url } = yield select((state) => state.commonReducer.commonProps);

  return {
    short_url,
    start_date,
    end_date,
    pdc_type: pdcType.id,
    payment_status: paymentStatus.id
  };
}

function* setDates() {
  const endDate = yield select((state) => state.pastDuesPerformance.currentUser.calendarEndDate);
  const startDate = dayjs(endDate).startOf("month").format(API_DATE_FORMAT);

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield fetchValues();

    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  yield setDates();

  try {
    yield fetchValues();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
